import { constants } from '@bedc/constants';
import { iotsUtils } from '@bedc/core';

export const Name = iotsUtils.fromList(constants.job.trussHitl.svg.names);
